import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, Text } from '@frontend/design-system';
import { flexColumnStyle } from './constant';

export interface TotalInvoicesCountProps extends React.ComponentPropsWithoutRef<'div'> {
  value?: number;
}

export const TotalInvoicesCount = ({ value = 0, ...rest }: TotalInvoicesCountProps) => {
  const { t } = useTranslation('payments');

  return (
    <div
      css={[
        flexColumnStyle,
        css`
          align-items: center;
          gap: ${theme.spacing(0.5)};
          justify-content: center;
        `,
      ]}
      {...rest}
    >
      <Heading
        as='p'
        css={css`
          font-size: 136px;
          margin: 0;
          line-height: 1;
        `}
      >
        {value > 99 ? '99+' : value}
      </Heading>
      <Text
        size='medium'
        weight='regular'
        css={css`
          margin: 0;
          color: ${theme.font.colors.subdued};
        `}
      >
        {t('Total invoices collected')}
      </Text>
    </div>
  );
};
